import stockService from 'stockService'
import utils from 'utils'

export default class distributionService {
    constructor($q, httpRequest) {
        this.$q = $q
        this.httpRequest = httpRequest
    }

    getDiskInfo() {
        return new Promise((resolve, reject) => {
            stockService.getDiskInfo().then((res) => {
                resolve(JSON.parse(res))
            }, () => {
                reject()
            })
        })
    }

    queryInvoiceStock() {
        return new Promise((resolve, reject) => {
            stockService.queryInvoiceStock().then((res) => {
                const reg = {
                    code: /(<CODE>)(.*?)(<\/CODE>)/g,
                    fpdm: /<LBDM>(.*?)<\/LBDM>/g,
                    fpzl: /<FPZL>(.*?)<\/FPZL>/g,
                    fphm: /<QSHM>(.*?)<\/QSHM>/g,
                    fpsysl: /<FPFS>(.*?)<\/FPFS>/g,
                    gmrq: /<GMRQ>(.*?)<\/GMRQ>/g,
                    id: /<FPJH>(.*?)<\/FPJH>/g,
                }
                resolve(utils.analysisXml(reg, res).value)
            })
        })
    }

    get_qryServerDiskOfPlugged(diskCode) {
        const service = this
        return new Promise((resolve, reject) => {
            service.httpRequest.get_qryServerDiskOfPlugged({ diskCode }).then((res) => {
                const reg = {
                    fpdm: /<TypeCode>(.*?)<\/TypeCode>/g,
                    fpzl: /<InvKind>(.*?)<\/InvKind>/g,
                    fphm: /<StartNO>(.*?)<\/StartNO>/g,
                    count: /<Count>(.*?)<\/Count>/g,
                    fpsysl: /<Remain>(.*?)<\/Remain>/g,
                    machineNo: /<Machine>(.*?)<\/Machine>/g,
                    gmrq: /<BuyDate>(.*?)<\/BuyDate>/g,
                    id: /<ID>(.*?)<\/ID>/g,
                }
                resolve({ analysisXml: utils.analysisXml(reg, res.data.value.reportXml).value, diskCode: res.data.value.diskCode })
            })
        })
    }

    queryDistribution(param) {
        return new Promise((resolve, reject) => {
            stockService.queryDistribution(param).then((res) => {
                const resCode = utils.analysisXml({
                    code: /(<CODE>)(.*?)(<\/CODE>)/g,
                }, res).code
                const resMsg = utils.analysisXml({
                    msg: /(<MESS>)(.*?)(<\/MESS>)/g,
                }, res).value[0]
                if (resCode == '0000') {
                    resolve()
                } else {
                    reject(resMsg.msg)
                }
            }, (error) => {
                reject(error)
            })
        })
    }

    post_allotServerDiskInvoice2Ukey(param) {
        const service = this
        return new Promise((resolve, reject) => {
            service.httpRequest.post_allotServerDiskInvoice2Ukey(param).then((res) => {
                if (res.data.msgCode == 0) {
                    resolve()
                } else {
                    reject()
                }
            })
        })
    }
}

distributionService.$inject = ['$q', 'httpRequest']



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/distribution/service/DistributionService.js